import React, { useEffect, useState } from 'react';

/** Renders initials (or another supplied fallback) if an avatar URL cannot load. */
export default function AvatarImage({ src, alt = 'avatar', className, style, fallback }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  if (!src || failed) return fallback;
  return <img src={src} alt={alt} className={className} style={style} onError={() => setFailed(true)} />;
}
